import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";

interface NavMenuComponentLightProps {
	selected: boolean;
    setSelected: (selected: boolean) => void;
    icon: React.ReactNode;
    text: string;
};

const NavMenuComponentLight: React.FC<NavMenuComponentLightProps> = ({ selected, setSelected, icon, text }) => {
    const { navMenuDisabled } = useSelector((state: RootState) => state.componentDisable);

    return (
        <ListItemButton disabled={navMenuDisabled} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRight: selected ? '5px solid #2c3e50' : 'none',
        }} onClick={() => setSelected(!selected)}>
            <ListItemIcon style={{
                display: 'flex',
                justifyContent: 'center',
            }}>
                {icon}
            </ListItemIcon>
            <ListItemText style={{
                textAlign: 'center'
            }} secondary={text} />
        </ListItemButton>
    );
};

export default NavMenuComponentLight;